import axios from 'axios';
import { useEffect, useState } from 'react';
import NotAvailableVirusScan from 'src/assets/img/not-available-virus-scan.png';
import NotAvailable from 'src/assets/img/not-available.png';
import { uint8ArrayToBase64 } from 'src/utils/fileTransformation';
import PDFViewer from './PDFViewer';

type PreviewPDFProps = {
  url: string;
  height?: string;
  className?: string;
  filename?: string;
  isOcr?: boolean;
  hoverPreview?: boolean;
};

function PreviewPDF({
  url,
  height,
  className,
  filename,
  isOcr,
  hoverPreview = false,
}: PreviewPDFProps) {
  const [src, setSrc] = useState('');
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      if (url) {
        try {
          const PdfArrayBufferBytes = await axios
            .get(url, { responseType: 'arraybuffer' })
            .then((res) => res.data);
          const blob: Blob = new Blob([PdfArrayBufferBytes], { type: 'application/pdf' });
          const dataUrl = uint8ArrayToBase64(new Uint8Array(PdfArrayBufferBytes));
          hoverPreview ? setSrc(window.URL.createObjectURL(blob)) : setSrc(dataUrl);
          setLoading(false);
          setError(false);
        } catch (error) {
          console.error(error);
          setSrc('');
          setError(true);
        } finally {
          setLoading(false);
        }
      } else {
        setError(true);
        setSrc('');
        setLoading(false);
      }
    })();
  }, [hoverPreview, url]);

  return (
    <>
      {loading ? (
        <div className="w-auto h-[calc(100vh-100px)] flex items-center justify-center">
          <span className="k-icon k-i-loading text-lg" />
        </div>
      ) : error ? (
        <img
          src={isOcr ? NotAvailableVirusScan : NotAvailable}
          alt="Not Available"
          className={`block mx-auto ${isOcr ? 'px-24' : ''}`}
        />
      ) : hoverPreview ? (
        <embed src={src} type="application/pdf" height={height} width="98%" className={className} />
      ) : (
        <PDFViewer height={height} data={src} fileName={String(filename)} />
      )}
    </>
  );
}

export default PreviewPDF;
